import { render, staticRenderFns } from "./ServiceDown.vue?vue&type=template&id=827fcf64&scoped=true"
import script from "./ServiceDown.vue?vue&type=script&lang=js"
export * from "./ServiceDown.vue?vue&type=script&lang=js"
import style0 from "./ServiceDown.vue?vue&type=style&index=0&id=827fcf64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827fcf64",
  null
  
)

export default component.exports